export default class SidebarSectionProduct extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isProductSectionExtended: false
    };
  }

  handleProductSectionExtendClick() {
    this.setState({
      isProductSectionExtended: !this.state.isProductSectionExtended
    });
  }

  render() {
    const canExtend = (
      !!this.props.order.data.product_customer_requirements_content
      || !!this.props.order.data.product_included_items_content
      || !!this.props.order.data.product_excluded_items_content
      || !!(this.props.order.data.product && this.props.order.data.product.url)
    )
    
    return (
      <div className={classNames("section NewOrderView-sidebar-section section-product section-to-extend",
        {"section-extended": this.state.isProductSectionExtended})}>
        <div className="section section-product-infos">
          {this.state.isProductSectionExtended && !!(this.props.order.data.product && this.props.order.data.product.main_image_file) && <div className="product-image" style={{
            backgroundImage: `url(${this.props.order.data.product.main_image_file.tile.url})`
          }} />}

          <h3 className="product-title">
            {!this.props.order.data.product && <span>{this.props.order.data.product_name}</span>}
            {!!this.props.order.data.product && (
              <a href={st.urlWithCurrentQuery(this.props.order.data.product.url)}>{this.props.order.data.product_name}</a>
            )}
          </h3>

          {canExtend && (
            <h2 className="section-title">
              {I18n.t("fe.sidebar_section_product.product_details")}
              &nbsp;
              <a className="section-extend-button" onClick={this.handleProductSectionExtendClick.bind(this)}>
                ({I18n.t("base.extend")} &darr;)
              </a>
            </h2>
          )}
        </div>

        {this.state.isProductSectionExtended && !!this.props.order.data.product_customer_requirements_content && (
          <div className="section">
            <h2 className="section-title">{I18n.humanAttributeName("product", "customer_requirements")}</h2>
            <div className="section-content wysiwyg-content" dangerouslySetInnerHTML={{__html: this.props.order.data.product_customer_requirements_content}}></div>
          </div>
        )}

        {this.state.isProductSectionExtended && !!this.props.order.data.product_included_items_content && (
          <div className="section">
            <h2 className="section-title">{I18n.humanAttributeName("product", "included_items")}</h2>
            <div className="section-content wysiwyg-content" dangerouslySetInnerHTML={{__html: this.props.order.data.product_included_items_content}}></div>
          </div>
        )}

        {this.state.isProductSectionExtended && !!this.props.order.data.product_excluded_items_content && (
          <div className="section">
            <h2 className="section-title">{I18n.humanAttributeName("product", "excluded_items")}</h2>
            <div className="section-content wysiwyg-content" dangerouslySetInnerHTML={{__html: this.props.order.data.product_excluded_items_content}}></div>
          </div>
        )}

        {this.state.isProductSectionExtended && !!(this.props.order.data.product && this.props.order.data.product.url) && (
          <a href={st.urlWithCurrentQuery(this.props.order.data.product.url)} className="product-read_more">{I18n.t("base.read_more")} &rarr;</a>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/SidebarSectionProduct.jsx